import * as Sentry from "@sentry/nuxt";

if (location.hostname === 'starry-spins.pages.dev' || location.hostname === 'starryspins.ft-crm.com') {
  Sentry.init({
    dsn: "https://23c50cb17476b04d5045c9ef1c7a2864@o73390.ingest.us.sentry.io/4507998511759360",
    tracesSampleRate: 1.0,
    integrations: [Sentry.browserTracingIntegration()],
  });
}
